<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AccountEditForm from '~/components/user/AccountEditForm.vue'

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()
const { authenticatedUser, isLoggedIn } = storeToRefs(authStore)
const showAccountEdit = ref(false)
const showInvestorEdit = ref(false)

function openAccountSettings() {
  showAccountEdit.value = true
}

function openInvestorSettings() {
  showInvestorEdit.value = true
}

const tabs = [
  { path: '/', icon: 'fa-thin fa-house', label: 'Home' },
  { path: '/portfolio', icon: 'fa-thin fa-money-bill-trend-up', label: 'Portfolio' },
  { path: '/analysis', icon: 'fa-thin fa-microchip-ai', label: 'Analysis' },
  // { action: openAccountSettings, icon: 'fa-thin fa-gear', label: 'Settings' },
]

whenever(authenticatedUser, () => {
  if (authenticatedUser.value && !authenticatedUser.value.investor_preferences) {
    setTimeout(openInvestorSettings, 500)
  }
}, { immediate: true })

const active = computed({
  get: () => tabs.findIndex(tab => tab.path === route.path),
  set: (val: number) => {
    const tab = tabs[val]
    if (tab) {
      if (tab.path) {
        router.push(tab.path)
      }
    }
  },
})
</script>

<template>
  <header>
    <div class="flex justify-between items-center">
      <section>
        <img src="/logos/logo-black.svg" class="h-[30px]">
      </section>

      <section v-if="isLoggedIn && authenticatedUser" class="flex justify-start items-center" @click="openAccountSettings">
        <div>
          <div class="text-[15px] mb-[-5px]">
            {{ authenticatedUser.name }}
          </div>
          <div v-if="false" class="text-xs">
            Free account
          </div>
        </div>
        <div class="ml-2">
          <div
            class="rounded-full w-9 h-9 bg-cover bg-center"
            :style="{ backgroundImage: `url(${authenticatedUser.avatar_url})` }"
          />
        </div>
      </section>
    </div>
  </header>

  <section v-if="isLoggedIn">
    <AccountEditForm :avatar-url="authenticatedUser?.avatar_url" :user="authenticatedUser" :is-open="showAccountEdit" @update:is-open="(open: boolean) => showAccountEdit = open" />
    <InvestorPreferencesForm :user="authenticatedUser" :is-open="showInvestorEdit" @update:is-open="(open: boolean) => showInvestorEdit = open" />

    <van-tabbar v-model="active">
      <van-tabbar-item
        v-for="(tab, index) in tabs"
        :key="index"
      >
        <template #icon>
          <i :class="tab.icon" />
        </template>
        {{ tab.label }}
      </van-tabbar-item>
    </van-tabbar>
  </section>
</template>
